import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { identityMicrosoftCallbackStart } from '../redux/identity/identitySlice';

const MicrosoftCallback = () => {
 const dispatch = useAppDispatch();
 const navigate = useNavigate();
 const [searchParams] = useSearchParams();
 const hasDispatched = useRef(false);

 const { success, loading, error } = useAppSelector((state) => state.identity);

 const code = searchParams.get('code');
 const redirectUri =
  searchParams.get('redirectUri') ||
  `${window.location.origin}/microsoft-callback`;

 useEffect(() => {
  if (code && !hasDispatched.current) {
   hasDispatched.current = true;
   dispatch(identityMicrosoftCallbackStart({ code, redirectUri }));
  }
 }, [code, redirectUri, dispatch]);

 useEffect(() => {
  if (success?.identityMicrosoftCallback) {
   navigate('/results', { replace: true });
  }
 }, [success?.identityMicrosoftCallback, navigate]);

 if (!code) {
  return (
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     alignItems: 'center',
     justifyContent: 'center',
     minHeight: '100vh',
     gap: 2,
    }}
   >
    <Typography variant="body1" color="error">
     Missing authorization code
    </Typography>
   </Box>
  );
 }

 if (error?.identityMicrosoftCallback) {
  return (
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     alignItems: 'center',
     justifyContent: 'center',
     minHeight: '100vh',
     gap: 2,
    }}
   >
    <Typography variant="body1" color="error">
     {error.identityMicrosoftCallback.title || 'Authentication failed'}
    </Typography>
   </Box>
  );
 }

 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: 2,
   }}
  >
   <CircularProgress />
   <Typography variant="body1">
    {loading?.identityMicrosoftCallback ? 'Signing in...' : 'Processing...'}
   </Typography>
  </Box>
 );
};

export default MicrosoftCallback;

